import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '@app/core/services/auth.service';
import { GeneralDesktopComponent } from '@app/pages/pages-no-auth/customer-order/general-desktop/general-desktop.component';
import { GeneralMobileComponent } from '@app/pages/pages-no-auth/customer-order/general-mobile/general-mobile.component';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-no-auth-customer-order',
  standalone: true,
  imports: [CommonModule, GeneralDesktopComponent, GeneralMobileComponent],
  templateUrl: './no-auth-customer-order.component.html',
  styleUrl: './no-auth-customer-order.component.scss',
})
export class NoAuthCustomerOrderComponent implements OnInit {
  screenSize!: string;

  private routeSub!: Subscription;

  constructor(
    private route: ActivatedRoute,
    private authService: AuthService,
    private router: Router
  ) {}

  ngOnInit(): void {
    // feature - auto-login from public order page to auth order page

    // if (!!this.authService.user.value) {
    //   this.routeSub = this.route.params.subscribe((params) => {
    //     const customerOrderId: string = params['id'];

    //     this.router.navigate(['/customer/customer-order/' + customerOrderId]);
    //   });
    // }

    this.screenSize = this.route.snapshot.data['screenSize'];
  }
}
